import React from "react";
import { FiltersWidget } from "ComponentsUI/SideWidgets";
import { observer, inject } from "mobx-react";

@inject("ApplicationModel")
@observer
export default class FiltersWidgetContainer extends React.Component {
    onClickHandler() {
        let model = this.props.ApplicationModel.fixedPanelModel;
        let node = model.filtersWidgetContent;
        let nodeTop = model.filtersWidgetContent.getBoundingClientRect().top;
        window.scrollTo(0, nodeTop + pageYOffset);
        model.uncollapseFilters();
    }

    render() {
        let classes = this.props.classes;
        let model = this.props.ApplicationModel.fixedPanelModel;
        if (!model.filtersWidgetIsVisible) {
            return null;
        }
        return <FiltersWidget onClickHandler={() => this.onClickHandler()} />;
    }
}
